/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  /*dev mang iswanto
  production: false,
  debug: true,
  api_url: 'http://localhost',
  api_url_local: 'http://localhost',
  // api_url_python: 'http://localhost:7091',
  // api_url_python: 'http://192.168.88.200:7091',
  // api_url_python: 'http://192.168.43.179:7091',
  api_url_python: 'http://202.150.150.134:7091',
  api_apiary: 'https://localhost',
  map_api_key: 'AIzaSyCyCQF0pCkYlvjmjmR-_SksZ2bGW2o7_XU',
*/
 //edit saat coding debug = T & Prod = F dan untuk compile sebaliknya
 production: true,
 debug: false,

 //IP Server Existing static IP change from 27 Agust 2021 http://202.150.150.134:7091
 //api_url:       'http://202.150.130.48:7091',
 //api_url_local: 'http://202.150.130.48:7091',
 //api_url_python: 'http://202.150.130.48:7091',
 //api_apiary:     'http://202.150.130.48:7091',

 //IP Server Existing domain
 api_url: 'http://tracking.cisangkan.co.id:7091',
 api_url_local: 'http://tracking.cisangkan.co.id:7091',
 api_url_python: 'http://tracking.cisangkan.co.id:7091',
 api_apiary: 'http://tracking.cisangkan.co.id:7091',

 //IP Server Experiment
 //api_url: 'http://172.73.1.140:7092',
 //api_url_local: 'http://172.73.1.140:7092',
 //api_url_python: 'http://172.73.1.140:7092',
 //api_apiary: 'http://172.73.1.140:7092',

 //api_url: 'http://localhost',
 //api_url_local: 'http://localhost',
 // api_url_python: 'http://localhost:7091',
 //api_url_python : 'http://172.73.1.94:7091',
 //api_url_python : 'http://192.168.43.179:7091',
 //api_url_python: 'http://202.150.150.134:7091',
 //api_apiary: 'https://localhost',
 map_api_key: 'AIzaSyCyCQF0pCkYlvjmjmR-_SksZ2bGW2o7_XU',
};